export default __webpack_public_path__ + "static/media/webBanner2.f117df77.png";